import EditBlockquote from '@guestbell/slate-edit-blockquote' // https://github.com/guestbell/slate-plugins
import CodeBlock from '../Plugins/SlateCodeBlock'

const editBlockquotePlugin = EditBlockquote({
	type: 'block-quote',
	typeDefault: 'paragraph',
})

const editHintPlugin = EditBlockquote({
	type: 'hint',
	typeDefault: 'paragraph',
})

const codeBlockPlugin = CodeBlock({
	containerType: 'code_block',
	lineType: 'code_line',
})

const commands = {
	insertFile(editor, file, id, treatAsFile = false) {
		// console.log('Uploading started …')

		// Memorize current block
		const currentBlock = editor.value.startBlock
		const formData = new FormData()

		formData.append('file', file)
		formData.append('article', id)

		const _URL = window.URL || window.webkitURL

		if (file.type && file.type.match('image.*') && !treatAsFile) {
			// Create image (for dimensions)
			const img = new Image()

			img.onload = () => {
				const block = {
					type: 'image',
					data: {
						name: file.name,
						height: img.height,
						width: img.width,
						formData,
					},
				}

				if (
					currentBlock.text.length === 0 &&
					currentBlock.type === 'paragraph'
				) {
					editor.setBlocks(block)
				} else {
					editor.insertBlock(block)
				}

				editor.insertBlock('paragraph').focus()
			}

			img.setAttribute('crossOrigin', 'anonymous')
			img.src = _URL.createObjectURL(file)
		} else {
			const block = {
				type: 'file',
				data: {
					name: file.name,
					type: file.type,
					size: file.size,
					lastModified: file.lastModified,
					formData,
				},
			}

			if (
				currentBlock.text.length === 0 &&
				currentBlock.type === 'paragraph'
			) {
				editor.setBlocks(block)
			} else {
				editor.insertBlock(block)
			}

			editor.insertBlock('paragraph').focus()
		}
	},
	wrapLink(editor, url) {
		editor.wrapInline({ type: 'link', data: { href: url } })
	},
	unwrapLink(editor) {
		editor.unwrapInline('link')
	},
	setHr(editor) {
		editor
			.setBlocks({ type: 'hr' })
			.insertBlock('paragraph')
			.focus()
	},
	setUnorderedList(editor) {
		// @TODO: Use EditList instead
		editor.setBlocks({ type: 'bulleted-list' })
	},
	setOrderedList(editor) {
		// @TODO: Use EditList instead
		editor.setBlocks({ type: 'numbered-list' })
	},
	setBlockquote(editor) {
		editBlockquotePlugin.changes.wrapInBlockquote(editor)
	},
	setH2(editor) {
		editor.setBlocks({ type: 'heading-two' })
	},
	setH3(editor) {
		editor.setBlocks({ type: 'heading-three' })
	},
	setTableOfContents(editor) {
		editor.setBlocks({ type: 'table-of-contents' })
	},
	setPageIndex(editor) {
		editor.setBlocks({ type: 'page-index' })
	},
	setCodeBlock(editor) {
		codeBlockPlugin.changes.wrapCodeBlock(editor)
	},
	setHint(editor) {
		editHintPlugin.changes.wrapInBlockquote(editor)
	},
	setYoutube(editor, url) {
		const youtube = url.match(
			/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
		)

		// https://www.youtube.com/watch?v=AeYbX0zaJTY
		if (youtube && youtube[7].length === 11) {
			editor.setBlocks({
				type: 'youtube',
				data: { id: youtube[7] },
			})

			return true
		}

		throw 'invalid_url'
	},
	setVimeo(editor, url) {
		const vimeo = url.match(
			/\/\/(?:www\.)?vimeo\.com\/(?:channels\/staffpicks\/)?([-\w]+)/i
		)

		if (vimeo && vimeo[1]) {
			// https://vimeo.com/23311782
			editor.setBlocks({
				type: 'vimeo',
				data: { id: vimeo[1] },
			})

			return true
		}

		throw 'invalid_url'
	},
	setDraw(editor, url) {
		if (url.includes('draw.io')) {
			editor.setBlocks({
				type: 'draw',
				data: { url },
			})

			return true
		}

		throw 'invalid_url'
	},
	setFigma(editor, url) {
		// https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FpIymjPcUwVS6iEZzxRrp9j%2FEmails-Newsletter%3Fnode-id%3D0%253A6293

		if (url.includes('figma.com')) {
			editor.setBlocks({
				type: 'figma',
				data: { url },
			})

			return true
		}

		throw 'invalid_url'
	},
	setGist(editor, url) {
		// https://gist.github.com/svenadlung/eb9fead18f9f2b760cbd773ea29fb9f4

		if (url.includes('gist.github.com')) {
			editor.setBlocks({
				type: 'gist',
				data: { url },
			})

			return true
		}

		throw 'invalid_url'
	},
	setCodepen(editor, url) {
		// https://codepen.io/JonasBadalic/pen/PwWXqg
		const codepen = url.match(
			/^.*(codepen.io\/)([a-zA-Z0-9]+)(\/pen\/)([a-zA-Z0-9]+)/i
		) // https://github.com/thedannywahl/moodle2-codepen-textfilter/blob/master/filter.php

		if (codepen && codepen.length >= 4 && codepen[4] && codepen[2]) {
			editor.setBlocks({
				type: 'codepen',
				data: {
					hash: codepen[4],
					author: codepen[2],
				},
			})

			return true
		}

		throw 'invalid_url'
	},
}

export default commands
